import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './aws-config';
import { clearSession, loadSession } from './utils/session';

// Components
import Layout from './components/Layout';
import Login from './pages/LoginNew';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import Users from './pages/Users';
import Stores from './pages/Stores';
import DashboardPages from './pages/DashboardPages';
import WhatsApp from './pages/WhatsApp';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // Check authentication status on app load
  useEffect(() => {
    const checkAuth = () => {
      const user = loadSession();

      if (user) {
        setIsAuthenticated(true);
        setUserInfo(user);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (loginResponse: any) => {
    setIsAuthenticated(true);
    setUserInfo({
      username: loginResponse.username,
      email: loginResponse.email,
      org_id: loginResponse.org_id,
      org_name: loginResponse.org_name,
      is_admin: loginResponse.is_admin
    });
  };

  const handleSignOut = () => {
    // Clear authentication data
    clearSession();
    setIsAuthenticated(false);
    setUserInfo(null);
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {!isAuthenticated ? (
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : (
          <Layout onSignOut={handleSignOut} username={userInfo?.username || ''} userInfo={userInfo}>
            <Routes>
              <Route path="/" element={<Dashboard userInfo={userInfo} />} />
              <Route path="/organizations" element={<Organizations userInfo={userInfo} />} />
              <Route path="/users" element={<Users userInfo={userInfo} />} />
              <Route path="/stores" element={<Stores userInfo={userInfo} />} />
              <Route path="/dashboard-pages" element={userInfo?.is_admin ? <DashboardPages userInfo={userInfo} /> : <Navigate to="/" replace />} />
              <Route path="/whatsapp" element={<WhatsApp userInfo={userInfo} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        )}
      </div>
    </Router>
  );
}

export default App;